import React from 'react';

import { ProfileDefaults } from '@paragon/contract-library';

import { loadProfileDefaults } from '../../../../../store/actions/loadActions';
import { saveProfileDefaults } from '../../../../../store/actions/settingsActions';
import { settingsShouldBeViewOnly } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import SettingsPanelContainer, { connectSettingsPanelContainer } from '../SettingsPanelContainer';
import { ProfileDefaultsControls } from './ProfileDefaultsControls';

const ProfileDefaultsSettingsContainer = connectSettingsPanelContainer(
  class extends SettingsPanelContainer<ProfileDefaults> {},
);

const INSERTION_SETTINGS_MESSAGE =
  'Not supported. Profile settings for an insertion component should be edited in the insertion panel.';
const INSERTION_MODE_HANDLER = () => {
  throw new Error(INSERTION_SETTINGS_MESSAGE);
};

export function ProfileDefaultsSettingsPanel() {
  const dispatch = useAppDispatch();

  const isViewOnly = useAppSelector(settingsShouldBeViewOnly);

  return (
    <ProfileDefaultsSettingsContainer
      isViewOnly={isViewOnly}
      controls={ProfileDefaultsControls}
      fetchSettings={{
        fromInsertionInfo: INSERTION_MODE_HANDLER,
        fromSettingsDatabase: (modelGuid) => dispatch(loadProfileDefaults(modelGuid)),
      }}
      disableSavingActualSettings
      onSave={{
        forInsertionComponent: INSERTION_MODE_HANDLER,
        forExistingModel: (settings, options) => dispatch(saveProfileDefaults(settings, options)),
      }}
    />
  );
}
